import { RichOption } from '@liscio/api';

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTH_RICH_OPTIONS: RichOption[] = MONTH_NAMES.map((name) => ({
  label: name,
  value: name,
  key: name,
  is_descending: false,
}));
